import styled from 'styled-components';

const Rep_ContentWrapper = styled.div`
  display: flex;
  & > div {
    padding-top: 1em;
    &:first-of-type {
      width: 74%;
      margin-right: 2em;
    }
    &:last-of-type {
      width: calc(26% - 2em);
    }
    &.only-unpaid{
      width: 100%;
      margin-right: 0;
    }
  }
`;

const Rep_GeneralWrapper = styled.div`
  margin: 0 auto;
  padding: 0 1em;
  max-width: 1600px;
  box-sizing: border-box;
  color: ${props => props.theme.color.text};
  min-height: calc(100vh - 90px);
  position: relative;
`;

const Rep_PageTitle = styled.h1`
  font-weight: normal;
  font-size: 2.3em;
  margin: 0.5em 0;
`;

export default {
  Rep_ContentWrapper,
  Rep_GeneralWrapper,
  Rep_PageTitle
};
